export default "__VITE_ASSET__f5d483fa__"